<template>
    <div>
        <div class="org-tree-layout" v-if="!tankuang">
            <swb-popover-org-tree :optionalState="[0,1,3]" :defalultState="[0,1,3]" :onlyShowRealCom="onlyShowRealCom" :showRealCom="true" :selectRealComId="realComId" :showMgmt="true" :bizDepart="true" :tmpBizDepart="false"
                                  :selectComId="selectComId" :showIncludeSubComs="true"
                                  :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>
        <div name="btn-bar" class="simple-row">
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="generalImport">导入</a>
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="viewImpRec()">查看导入记录</div>
                <!--<div class="swb-btn swb-btn-small swb-btn-primary" @click="exportAllAsExcel(null)">导出列表</div>-->
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="taskExport()">执行导出任务</div>
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="viewTaskExport()">查看结果文件</div>
                <div class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('set_contract') && !tankuang" @click="setInitContractNo">
                    <span>关联原采购合同</span>
                </div>
                <div class="swb-btn swb-btn-small swb-btn-primary" @click="toRevoke" v-if="bizType != 'revoke' && !tankuang">资产冲销记录</div>
            </div>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher, getComnMerchantBizTag} from '../../app.vues'
    import {checkUserActionPerm, getMerchtAssetNatureMap} from '../index'
    import {getDefaultPageSizes} from '../../app.conf'
    import {openBizDepartDlg} from '../orgStruct/selectDlg'
    import {showDownloadDlg} from '../ctrl/dialog'
    import {
        loadShopWarehouseList,
        loadRetailerDevcGroupList,
        loadDevcCatListList
    } from '../retailer/asset-comn'
    import {showAsmblAccStockSetSelectDlg} from '../asmblAcc/dialog';
    import {showMerchtDevcDefSelectDlg, openDeprSpecDetailDlg} from '../devcDef/showDlg';
    import {openAssetDeprPlanReportDlg} from '../assetDepr/showDlg'
    import {openContractGoodsListDlg} from '../contract/dialog'
    import {getIncludeSubComsByMetaQueryConf} from '../conf/ComnConfStorer'
    import {fileUploadGroupShowDlg} from '../comn/dialog'
    import {createTaskExportDlg, viewTaskExportListDlg} from './selectDlg'
    //
    import devcApi from '../../api/devc';
    import userApi from '../../api/user'
    import comnApi from '../../api/comn'

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);

    import SwbAssetRevokeListMain from '../retailer/AssetRevokeListMain';

    Routes.add(SwbAssetRevokeListMain);

    import SwbShopDeviceAssetInfo from './ShopDeviceAssetInfo';

    Vue.regist(SwbShopDeviceAssetInfo);

    import SwbShopDevcImpRecAssetUpdateList from './ShopDevcImpRecAssetUpdateList';

    Vue.regist(SwbShopDevcImpRecAssetUpdateList);

    import SwbShopDeviceTransVoucherApplyList from '../transVoucher/ShopDeviceTransVoucherApplyList';
    import SwbShopDeviceTransVoucherAuditList from '../transVoucher/ShopDeviceTransVoucherAuditList';
    import SwbShopDeviceTransVoucherDevcApplyList from '../tranVoucherDevc/ShopDeviceTransVoucherApplyList';
    import SwbShopDeviceTransVoucherDevcAuditList from '../tranVoucherDevc/ShopDeviceTransVoucherAuditList';
    import SwbShopDeviceScrapVoucherApplyList from '../scrapVoucher/ShopDeviceScrapVoucherApplyList';
    import SwbShopDeviceScrapVoucherAuditList from '../scrapVoucher/ShopDeviceScrapVoucherAuditList';
    import SwbShopDeviceClearVoucherApplyList from '../clearVoucher/ShopDeviceClearVoucherApplyList';
    import SwbShopDeviceClearVoucherAuditList from '../clearVoucher/ShopDeviceClearVoucherAuditList';
    import SwbAssetDeprAdjustVoucherList from '../assetFiscal/AssetDeprAdjustVoucherList';
    import SwbAssetDeprAdjustVoucherAuditList from '../assetFiscal/AssetDeprAdjustVoucherAuditList';
    import SwbDevcSplitFormList from '../devcSplit/DevcSplitFormList';
    import SwbDevcMergeFormList from '../devcMerge/DevcMergeFormList';
    import SwbPurchReceiptManualList from '../receipt/PurchReceiptManualList';
    import SwbShopDeviceAppturnVoucherList from '../retailer/ShopDeviceAppturnVoucherList';
    import SwbShopDeviceAppReturnVoucherList from '../retailer/ShopDeviceAppReturnVoucherList';

    Routes.add(SwbShopDeviceTransVoucherApplyList);
    Routes.add(SwbShopDeviceTransVoucherAuditList);
    Routes.add(SwbShopDeviceTransVoucherDevcApplyList);
    Routes.add(SwbShopDeviceTransVoucherDevcAuditList);
    Routes.add(SwbShopDeviceScrapVoucherApplyList);
    Routes.add(SwbShopDeviceScrapVoucherAuditList);
    Routes.add(SwbShopDeviceClearVoucherApplyList);
    Routes.add(SwbShopDeviceClearVoucherAuditList);
    Routes.add(SwbAssetDeprAdjustVoucherList);
    Routes.add(SwbAssetDeprAdjustVoucherAuditList);
    Routes.add(SwbDevcSplitFormList);
    Routes.add(SwbDevcMergeFormList);
    Routes.add(SwbPurchReceiptManualList);
    Routes.add(SwbShopDeviceAppturnVoucherList);
    Routes.add(SwbShopDeviceAppReturnVoucherList);

    let bizTagObj = null;
    export default {
        name: 'swb-shop-device-asset-list',
        desc: '资产列表',
        path: '/shop/device/asset/list',
        props: {
            filterItem: {
                type: Object,
                default: {}
            },
            onlyShowRealCom: {
                type: Boolean,
                default: null
            },
            realComId: {
                type: Number,
                default: null
            },
            tankuang: { // 弹框
                type: Boolean,
                default: null
            },
            paramsConfKey: {
                type: String,
                default: 'swb-shop-device-asset-list'
            },
            bizType: {
                type: String,
                default: 'fiscal'
            }
        },
        data: function () {
            return {
                confKey: 'swb-shop-device-asset-list',
                tableHeight: 580,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                resultColConf: {//不想要列配置设置 = null即可
                    metaColList: []
                },
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //排序、搜索
                queryConfig: {},
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                exportParmas: null,
                //
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                assetTypeMap: getEnumMap('assetType', 'value2text'),
                acctEnterWayMap: getEnumMap('acctEnterWay', 'value2text'),
                startValue: getEnumInfoWith('deviceUseState', 'name', 'Start').value,
                inactiveValue: getEnumInfoWith('deviceUseState', 'name', 'Inactive').value,
                outageValue: getEnumInfoWith('deviceUseState', 'name', 'Outage').value,
                leaseStateMap: getEnumMap('leaseState', 'value2text'),
                devcVoucherTypeMap: getEnumMap('devcVoucherType', 'value2text'),
                //
                initIncludeSubComs: false,
                selectComId: null,
                scopeEntity: {},
                filterItem: {},
                initQuery: true
            }
        },
        created: function () {
            let self = this;
            if (!Utils.isNoB(this.paramsConfKey)) {
                this.confKey = this.paramsConfKey;
            }
            //
            if (!Utils.isTrue(this.tankuang)) {
                this.filterItem = this.$route.query.filter || {};
                this.filterItem.importNo = this.$route.query.importNo || null;
                if (!Utils.isNoB(this.$route.query.includeSubComs)) {
                    this.filterItem.includeSubComs = this.$route.query.includeSubComs;
                }
                //
                this.filterItem.retailerComId = this.$route.query.selectComId || null;
            }
            this.selectComId = this.filterItem.retailerComId || null;
            //
            bizTagObj = getComnMerchantBizTag();
            this.getCurrentUserInfo();
            //
            getIncludeSubComsByMetaQueryConf('swb-shop-device-asset-list', function (includeSubComs) {
                self.filterItem.includeSubComs = includeSubComs;
                self.initIncludeSubComs = includeSubComs;
            });
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            if (!Utils.isTrue(self.tankuang)) {
                let thisEl = $(this.$el);
                $(this.$el).addClass('overflow-hidden');
                //
                let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
                domSizeWatcher.setBaseEl(thisEl);
                domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                    //根据新主元素的内容大小，调整表格高度
                    self.tableHeight = height;
                });
                //domSizeWatcher.setHrEls();
                domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], .org-tree-layout, [name="btn-bar"]'));
                domSizeWatcher.start(500);
            }
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            checkComCatChange: function (eventData) {
                let filterItem = this.filterItem || {};
                if (Utils.isTrue(eventData.realFlag)) {
                    filterItem.retailerRealComId = eventData.id;
                    filterItem.selectPrftCenterCode = null;
                } else if (Utils.isTrue(eventData.centerFlag)) {
                    filterItem.retailerRealComId = eventData.realComId;
                    filterItem.selectPrftCenterCode = eventData.code;
                } else {
                    filterItem.retailerComId = eventData.id;
                    filterItem.retailerComId = eventData.id;
                    filterItem.includeSubComs = eventData.includeSubComs;
                }
                this.filterItem = Utils.merge({}, filterItem);
                //
                if (!Utils.isTrue(this.initQuery)) {
                    this.getShopDeviceList();
                }
            },
            onQueryConfigReady: function () {
                this.initAsyncQueryModel();
            },
            initAsyncQueryModel() {
                let self = this;
                let filter = self.filterItem;
                let comId = filter.retailerComId;
                // 分类分组
                loadRetailerDevcGroupList(function (dataList) {
                    self.updateQueryModelField('devcGroupId', dataList);
                });
                // 加载仓库
                loadShopWarehouseList(comId, function (dataList) {
                    self.updateQueryModelField('warehouseId', dataList);
                });
                // 资产分类
                loadDevcCatListList(function (dataList) {
                    self.updateQueryModelField('innerDevcCatId', dataList);
                });
                // 资产属性
                getMerchtAssetNatureMap((merchtAssetNatureList) => {
                    if (merchtAssetNatureList.length > 0) {
                        let dataList = [{'value': null, 'label': '- 全部 -'}];
                        merchtAssetNatureList.forEach(function (item) {
                            let dataInfo = {};
                            dataInfo.value = item.value;
                            dataInfo.label = item.text;
                            dataList.push(dataInfo);
                        });
                        this.updateQueryModelField('assetNature', dataList);
                    }
                });
                //
                let tmpNo = filter.tmpNo;
                if (!Utils.isNoB(tmpNo)) {
                    self.updateQueryModelValueField('tmpNo', tmpNo);
                }
                //
                let importNo = filter.importNo;
                if (!Utils.isNoB(importNo)) {
                    self.updateQueryModelValueField('importNo', importNo);
                }
                //
                let title = filter.title;
                if (!Utils.isNoB(title)) {
                    self.updateQueryModelValueField('title', title);
                }
                //
                // 门店标签是否显示
//                    let hidden = !Utils.isNoB(filter.shopFlag) && Utils.isTrue(filter.shopFlag);
//                    self.updateQueryModelHiddenField("retailerShopTagId", hidden);
                //
                bizTagObj.loadSelectBizTagByBizAspect(1, function (dataList) {
                    self.updateQueryModelField('bizTag', dataList);
                });
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                //
                let acctEnterWay = getEnumList('acctEnterWay');
                let dataList = [];
                acctEnterWay.forEach(function (item) {
                    let queryAcctEnterWay = {
                        value: item.value,
                        label: item.text
                    };
                    dataList.push(queryAcctEnterWay);
                });
                let acctEnterWayMap = {};
                acctEnterWayMap['acctEnterWay'] = {dataList: dataList};
                query_model_ctrl.updateFields(acctEnterWayMap);
                // 当传过来的参数有财务异常的时候，财务异常条件搜索隐藏
                let fiscalAbnormal = filter.fiscalAbnormalX;
                if (!Utils.isNoB(fiscalAbnormal)) {
                    let fiscalAbnormalMap = {};
                    fiscalAbnormalMap['fiscalAbnormal'] = {hidden: true};
                    query_model_ctrl.updateFields(fiscalAbnormalMap);
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelValueField: function (itemCode, dataValue) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {value: dataValue};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelHiddenField: function (itemCode, hiddenValue) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {hidden: hiddenValue};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            popupHandler: function (fieldCode, curValue, curText) {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let filterItem = this.filterItem || {};
                let thisComId = Utils.isNoB(filterItem.retailerComId) ? this.scopeEntity.comId : filterItem.retailerComId;
                if (fieldCode == 'respblDepartId') {
                    openBizDepartDlg(thisComId, function (bizDepart) {
                        let fieldInfo = {
                            respblDepartId: {
                                value: bizDepart.id,
                                text: bizDepart.name
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'statusLabel': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.wrntDueTime != null && new Date(row.currentTime).getTime() > new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保外</a>';
                        }
                        if (row.wrntDueTime == null || new Date(row.currentTime).getTime() <= new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保内</a>';
                        }
                        if (row.tagMissing) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">缺码</a>';
                        }
                        return domHtml;
                    },
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if (!Utils.isNoB(row.imageUrl)) {
                            return '<a href="#"><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                        } else {
                            return '';
                        }
                    },
                    'assetTypeTitle': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.assetTypeMap[row.assetType] + '</span>';
                    },
                    'fiscalAcctName': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + (row.fiscalAcctFlag == 1 ? '是' : '否') + '</span>';
                    },
                    'indoubtName': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + (row.indoubtFlag == 1 ? '是' : '否') + '</span>';
                    },
                    'assetNatureName': function (row, colName, colValue, rowIndex) {
                        return '<span>' + self.assetNatureMap[row.assetNature] + '</span>';
                    },
                    'acctEnterWayName': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.acctEnterWayMap[row.acctEnterWay] + '</span>';
                    },
                    'canScrapQuantity': function (row, colName, colValue, rowIndex, colConf) {
                        let quantity = row.fiscalQuantity - row.scrappedQuantity;
                        if (quantity <= 0) {
                            quantity = 0;
                        }
                        return '<span>' + quantity + '</span>';
                    },
                    'bizTag': function (row, colName, colValue, rowIndex, colConf) {
                        if (!Utils.isNoB(row.bizTag)) {
                            let bizTag = row.bizTag;
                            let tagIdList = [];
                            if (!Utils.isNoB(bizTag)) {
                                if (bizTag.indexOf('|') >= 0) {
                                    tagIdList = bizTag.split('|') || [];
                                } else {
                                    return '<span class="swb-tags swb-tags-success mr5">' + bizTag + '</span>';
                                }
                            }
                            let html = '';
                            for (let i = 0; i < tagIdList.length; i++) {
                                let tagId = tagIdList[i];
                                let tagName = bizTagObj.getBizTagNameById(tagId);
                                if (tagName != null) {
                                    html += '<span class="swb-tags swb-tags-success mr5">' + tagName + '</span>';
                                }
                            }
                            return html;
                        }
                    },
                    'suitMainFlag': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.suitId != null) {
                            if (row.suitMainFlag) {
                                domHtml = '<span class="font-green">是</span>';
                            } else {
                                domHtml = '<span>否</span>';
                            }
                        }
                        return domHtml;
                    },
                    'imported': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'inUse': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'useStateName': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.useState == self.inactiveValue) {
                            domHtml = '<span class="font-black">未启用</span>';
                        } else if (row.useState == self.outageValue) {
                            domHtml = '<span class="font-gold">已停用</span>';
                        } else if (row.useState == self.startValue) {
                            domHtml = '<span class="font-green">已启用</span>';
                        }
                        return domHtml;
                    },
                    'scrapped': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'lockedX': function (row, colName, colValue, rowIndex) {
                        return (Utils.isTrue(row.fiscalLocked) || Utils.isTrue(row.locked)) ? '<span>是</span>' : '<span>否</span>';
                    },
                    'fiscalLockBizTypeText': function (row, colName, colValue, rowIndex) {
                        if (Utils.isTrue(row.fiscalLocked)) {
                            return '<span>' + self.devcVoucherTypeMap[row.fiscalLockBizType] + '</span>';
                        } else if (Utils.isTrue(row.locked)) {
                            return '<span>' + self.devcVoucherTypeMap[row.lockBizType] + '</span>';
                        } else {
                            return '';
                        }
                    },
                    'fiscalLockBizInnerNo': function (row, colName, colValue, rowIndex) {
                        if (Utils.isTrue(row.fiscalLocked)) {
                            return '<a class="table-cell-link">' + row.fiscalLockBizInnerNo + '</a>';
                        } else if (Utils.isTrue(row.locked)) {
                            return '<a class="table-cell-link">' + row.lockBizInnerNo + '</a>';
                        } else {
                            return '';
                        }
                    },
                    'devcDefFlagName': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.devcDefId == -1) {
                            return '<span>未关联</span>';
                        } else {
                            return '<span>已关联</span>';
                        }
                    },
                    'currentMonthDepr': function (row, colName, colValue, rowIndex, colConf) {
                        let month = new Date().format('yyyyMM');
                        if (row.lastDeprMonth == month) {
                            return row.lastDeprWorth;
                        } else {
                            return null;
                        }
                    },
                    'leaseState': function (row, colName, colValue, rowIndex, colConf) {
                        return self.leaseStateMap[colValue];
                    },
                    'stateTag': function (row, colName, colValue, rowIndex, colConf) {  // 状态标签
                        let html = '';
                        if (row.abscent) {
                            return '<span class="swb-tags swb-tags-success mr5">无实物</span>';
                        }
                        // 非业务
                        if (row.repairingFlag == 0 && row.idleFlag == 0 && !row.maintingFlag && !row.scrapped && !row.currExamineFlag) {
                            if (row.useState == 2) { // 已停用
                                html += '<span class="swb-tags swb-tags-success mr5">闲置</span>';
                            } else {
                                html += '<span class="swb-tags swb-tags-success mr5">正常使用</span>';
                            }
                        } else {
                            if (row.repairingFlag == 1) {
                                html += '<span class="swb-tags swb-tags-success mr5">维修</span>';
                            }
                            if (row.idleFlag == 1) {
                                html += '<span class="swb-tags swb-tags-success mr5">闲置</span>';
                            }
                            if (row.maintingFlag) {
                                html += '<span class="swb-tags swb-tags-success mr5">保养</span>';
                            }
                            if (row.scrapped) {
                                html += '<span class="swb-tags swb-tags-success mr5">报废</span>';
                            }
                            if (row.currExamineFlag) {
                                html += '<span class="swb-tags swb-tags-success mr5">检验</span>';
                            }
                        }
                        return html;
                    },
                    'deprSpecCode': function (row, colName, colValue, rowIndex) {
                        if (row.deprSpecId != null && row.deprSpecId != -1) {
                            return '<a class="table-cell-link">' + row.deprSpecCode + '</a>';
                        }
                    },
                    'fiscalDurableYears': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.deprable) {
                            return (row.durableLife - row.leftMonths) || 0;
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        if (self.bizType != 'revoke' && self.checkActionPerm('modify', null, row.retailerComId) && !Utils.isTrue(self.tankuang)) {
                            btnList.push({
                                name: 'modify',
                                text: '编辑'
                            });
                        }
                        if (self.checkActionPerm('view_detail', null, row.retailerComId)) {
                            btnList.push({
                                name: 'view_detail',
                                text: '详情'
                            });
                        }
                        if (self.checkActionPerm('view_rec', null, row.retailerComId)) {
                            btnList.push({
                                name: 'view_rec',
                                text: '操作记录'
                            });
                        }
                        if (self.bizType != 'revoke' && self.checkActionPerm('set_kind', null, row.retailerComId) && row.rented && !Utils.isTrue(self.tankuang)) {
                            btnList.push({
                                name: 'set_kind',
                                text: '设置类别'
                            });
                        }
                        if (self.checkActionPerm('useAsmblAcc', null, row.retailerComId) && row.asmblFlag && !row.asmblDone) {
                            btnList.push({
                                name: 'useAsmblAcc',
                                text: '组装'
                            });
                        }
                        if (self.checkActionPerm('change_def', null, row.retailerComId)) {
                            btnList.push({
                                name: 'change_def',
                                text: '更换定义'
                            });
                        }
                        if (self.checkActionPerm('view_depr_plan', null, row.retailerComId) && !row.fiscalAbnormal && row.deprMethodCode != 'NONE' && row.deprMethodCode != 'ONCE') {
                            btnList.push({
                                name: 'view_depr_plan',
                                text: '查看折旧计划'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(row.imageUrl);
                    },
                    'deprSpecCode': function (row, colName, colValue, rowIndex, btnName) {
                        if (row.deprSpecId != null && row.deprSpecId != -1) {
                            self.showDeprSpec(row.deprSpecId);
                        }
                    },
                    'fiscalLockBizInnerNo': function (row, colName, colValue, rowIndex, btnName) {
                        if (Utils.isTrue(row.fiscalLocked) || Utils.isTrue(row.locked)) {
                            self.toLockedBizVoucher(row);
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName, evnt) {
                        if (btnName == 'modify') {
                            self.editSvcSubNo(row.id);
                        } else if (btnName == 'view_detail') {
                            self.showSvcSubNoInfo(row);
                        } else if (btnName == 'view_rec') {
                            self.showSvcSubNoRec(row.id);
                        } else if (btnName == 'set_kind') {
                            self.setSvcSubNoAssetKind(row.id, row.assetKindId);
                        } else if (btnName == 'useAsmblAcc') {
                            self.useAsmblAcc(row);
                        } else if (btnName == 'change_def') {
                            // 更换定义
                            self.changeDevcDef(row);
                        } else if (btnName == 'view_depr_plan') {
                            // 查看折旧计划
                            self.toViewDeprPlan(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log('----- 双击数据行 ----');
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.scopeEntity = scopeEntity;
                        //
                        let filterItem = self.filterItem || {};
                        filterItem.retailerComId = scopeEntity.bizUnitId;
                        self.filterItem = Utils.merge({}, filterItem);
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            checkActionPerm: function (action, targetPostId, dataOwnerComId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId, dataOwnerComId);
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //
                this.getShopDeviceList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log('分页 => 第【' + pageNumber + '】页，大小：' + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getShopDeviceList();
            },
            getShopDeviceList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.devcBizClolumType = getEnumInfoWith('devcBizClolumType', 'name', 'TaiZhangMX').name;
                let filter = self.filterItem || {};
                filterItems = Object.assign(filterItems, filter);
                //
                if (!Utils.isNoB(filter.fiscalAbnormalX)) {
                    filterItems.fiscalAbnormal = filter.fiscalAbnormalX;
                }
                if (!Utils.isNoB(filter.retailerRealComId)) {
                    filterItems.useRealQuery = true;
                }
                if (Utils.isTrue(filterItems.useRealQuery)) {
                    filterItems.retailerComId = null;
                    filterItems.retailerComId = null;
                }
                if (!Utils.isNoB(filter.selectPrftCenterCode)) {
                    filterItems.prftCenterCode = filter.selectPrftCenterCode;
                    filterItems.usePrftCenterQuery = true;
                }
                let suitIds = filterItems.suitIds;
                if (!Utils.isNoB(suitIds)) {
                    filterItems.suitIds = suitIds.split('_');
                }
                if (!Utils.isNoB(filterItems.assetKindId)) {
                    filterItems.kindLevelFlag = true;
                }
                let bizType = self.bizType;
                if (bizType == 'revoke') {
                    filterItems.orgWorthRevoke = true;
                } else {
                    filterItems.fiscalAcctFlag = 1;
                    filterItems.fiscalOutFlag = 0; // 未财务清理的
                }
                //
                if (Utils.isTrue(filterItems.onlyQueryDeprAsset)) {
                    filterItems.fiscalAcctFlag = null;
                    filterItems.fiscalOutFlag = null;
                }
                //
                filterItems.deprFlag = true;
                filterItems.cleared = false;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                self.exportParmas = filterItems;
                //
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceListByFilter(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let data = result.data;
                        let list = data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                        //
                        self.renderTable(list, pagination);
                        if (Utils.isTrue(self.initQuery)) {
                            self.initQuery = false;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 编辑
            editSvcSubNo: function (devcId) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '编辑',
                    width: 700,
                    height: 800,
                    showCloseBtn: true,
                    template: '<swb-shop-device-svcSubNo-edit :showDevcCustTag="false" :devcId="devcId" :fuscakAcc="true" ref="shop_device_svcSubNo_edit"></swb-shop-device-svcSubNo-edit>',
                    data: {
                        devcId: devcId,
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.shop_device_svcSubNo_edit.getDlgResult();
                        if (!Utils.isNoB(result)) {
                            if (result.type == 'info') {
                                let postData = result.data;
                                let theLoad = MsgBox.loading();
                                devcApi.updateShopDevice(postData, function (result) {
                                    theLoad.hide();
                                    if (result.type === 'info') {
                                        theDlg.close();
                                        MsgBox.success('操作成功！');
                                        //
                                        self.getShopDeviceList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                MsgBox.warning(result.message);
                            }
                        }
                        return false;
                    }
                });
            },
            // 查看详情
            showSvcSubNoInfo: function (row) {
                Vue.$showDialog({
                    title: '资产财务 - 详情',
                    width: -400,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<swb-shop-device-asset-info :deviceId="deviceId" ref="swb_shop_device_asset_info"></swb-shop-device-asset-info>',
                    data: {
                        deviceId: row.id,
                    }
                });
            },
            // 查询记录
            showSvcSubNoRec: function (id) {
                Vue.$showDialog({
                    title: '资产操作记录 - 查看',
                    width: 1200,
                    height: 750,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<div>' +
                        '<swb-shop-device-act-rec-list :showComFlag="false" :deviceXId="id" :durable="durable" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>' +
                        '</div>',
                    data: {
                        id: id,
                        durable: false
                    }
                });
            },
            //
            setSvcSubNoAssetKind: function (id, assetKindId) {
                let self = this;
                let assetKindList = self.assetKindList;
                let theDlg = Vue.$showDialog({
                    title: '财务类别 - 设置',
                    showCloseBtn: true,
                    width: 500,
                    height: 300,
                    template: '<div class="form-info">' +
                        '<div class="form-row">' +
                        '<div class="form-label">' +
                        '<label>财务类别</label>' +
                        '</div>' +
                        '<div class="form-value width-1-5x">' +
                        '<el-select v-model="assetKindId" clearable placeholder="请选择">' +
                        '<el-option v-for="assetKind in assetKindList" :key="assetKind.id" :label="assetKind.name" :value="assetKind.id"></el-option>' +
                        '</el-select>' +
                        '</div>' +
                        '</div>' +
                        '</div>',
                    data: {
                        assetKindList: assetKindList,
                        assetKindId: assetKindId,
                    },
                    methods: {},
                    okClicked: function () {
                        let postData = {};
                        postData.assetType = 0;
                        postData.ids = [id];
                        postData.assetKindId = null;
                        postData.assetKindName = null;
                        //
                        let assetKindList = this.assetKindList;
                        let assetKindId = this.assetKindId;
                        if (!Utils.isNoB(assetKindId)) {
                            let currrItem = assetKindList.find(function (item) {
                                return item.id == assetKindId;
                            });
                            if (!Utils.isNoB(currrItem)) {
                                postData.assetKindId = currrItem.id;
                                postData.assetKindName = currrItem.name;
                            }
                        }
                        let theLoad = MsgBox.loading();
                        devcApi.updateAssetKind(postData, function (result) {
                            theLoad.hide();
                            if (result.type == 'info') {
                                theDlg.close();
                                MsgBox.success('操作成功！');
                                //
                                self.getShopDeviceList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                        return false;
                    },
                    lifecycle: {}
                });
            },
            // 使用组件
            useAsmblAcc: function (row) {
                let self = this;
                let params = {
                    shopDevcId: row.id
                };
                showAsmblAccStockSetSelectDlg(params, function (resultData, theDlag) {
                    let postData = {
                        id: row.id,
                        shopAsmblAccIoRecList: resultData.asmblRelList,
                        asmblDone: resultData.asmblDone
                    };
                    let theLoad = MsgBox.loading();
                    devcApi.saveShopAsmbleAccIoRecForAssect(postData, function (result) {
                        theLoad.hide();
                        if (result.type == 'info') {
                            theDlag.close();
                            MsgBox.success('操作成功');
                            //
                            self.getShopDeviceList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            },
            // 更换定义
            changeDevcDef: function (row) {
                let self = this;
                let assetType = getEnumInfoWith('assetType', 'name', 'CommonDevc').value;
                showMerchtDevcDefSelectDlg({
                    assetType: assetType,
                    normalized: Utils.isTrue(row.fiscalAcctFlag == 1) ? true : null,
                    exceptDevcDefId: (Utils.isNoB(row.devcDefId) || row.devcDefId == -1) ? null : row.devcDefId
                }, function (devcDef, dlg) {
                    //弹出确认框
                    self.$confirm('确定要更换定义吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        dlg.close();
                        //
                        let postData = {
                            id: row.id,
                            oldDevcDefId: row.devcDefId,
                            devcDefId: devcDef.id,
                            assetType: assetType
                        };
                        let theLoad = MsgBox.loading();
                        devcApi.doChangeAssetDevcDef(postData, function (result) {
                            theLoad.hide();
                            if (result.type === 'info') {
                                MsgBox.success('操作成功！');
                                //
                                self.getShopDeviceList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }).catch(function () {

                    });
                });
            },
            // 查看折旧计划
            toViewDeprPlan: function (row) {
                let params = {
                    assetInfo: row,
                    showTab: false
                };
                openAssetDeprPlanReportDlg(params);
            },
            toRevoke() {
                openPageRouteUrl(null, '/bench/home', SwbAssetRevokeListMain.path);
            },
            // 设置初始合同
            setInitContractNo() {
                let self = this;
                let catId = null;
                let brandId = null;
                let realComId = null;
                let shopDeviceSvcSubNos = self.getTableSelection();
                if (shopDeviceSvcSubNos.length == 0) {
                    MsgBox.warning('请选择要关联初始合同的资产！');
                    return;
                } else {
                    let catIds = [];
                    let brandIds = [];
                    let realComIds = [];
                    for (let i = 0; i < shopDeviceSvcSubNos.length; i++) {
                        let shopDeviceSvcSubNo = shopDeviceSvcSubNos[i];
                        catId = shopDeviceSvcSubNo.catId;
                        brandId = shopDeviceSvcSubNo.brandId;
                        if (!catIds.contains(catId)) {
                            catIds.push(catId);
                        }
                        if (!brandIds.contains(brandId)) {
                            brandIds.push(brandId);
                        }
                        if (!realComIds.contains(shopDeviceSvcSubNo.retailerRealComId)) {
                            realComIds.push(shopDeviceSvcSubNo.retailerRealComId);
                        }
                    }
                    if (realComIds.length > 1) {
                        MsgBox.warning('只能选择同一公司的资产！');
                        return;
                    } else {
                        realComId = realComIds[0];
                    }
                    if (catIds.length > 1 || brandIds.length > 1) {
                        MsgBox.warning('请选择相同分类品牌的资产！');
                        return;
                    }
                }
                let params = {
                    shopDeviceSvcSubNos: shopDeviceSvcSubNos,
                    realComId: realComId,
                    catId: catId,
                    brandId: brandId
                };
                openContractGoodsListDlg(params, function (success) {
                    if (success) {
                        let resultTable = self.$refs['result_table'];
                        resultTable.setInitChecked([]);
                        //
                        self.getShopDeviceList();
                    }
                });
            },
            //
            exportAllAsExcel(type) {
                let title = '资产卡片列表';
                //
                let fileName = title + new Date().format('yyyy_MM_dd') + '.xlsx';
                let url = getAppUrl('/file/export/as/excel');
                let tableData = this.getTableData(null, null, type);
                let data = Utils.merge({
                    //指示要一次性单个文件全部导出（最大导出条数 受限于 系统参数 "Xls全量导出最大行数限制"）
                    exportAllAtOnce: true,
                    //指示分批请求数据条目数（每条字段数越大，此值应该越小，【可选】，默认取值（并受限）于系统参数 "Xls全量导出每批量数限制"）
                    exportBatchSize: 1000,
                    //
                    fileName: fileName
                }, tableData);
                let fileInfo = {
                    url: url,
                    post: true,
                    fileName: fileName,
                    data: data
                };
                showDownloadDlg(title, fileInfo, true);
            },
            getTableData(pages, pageSize, type) {
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                if (type != null && type == 'outerUnsettled') {
                    delete tableData.qryItems;//减少数据传输量
                    let exportCols = [{
                        'name': 'tmpNo',
                        'title': '系统编号',
                        'width': 350,
                        'dataType': 'string',
                        'align': 'center',
                        'overflowAsTip': false,
                        'format': null,
                        'asTpl': false
                    }, {
                        'name': 'innerNo',
                        'title': '外部系统编号',
                        'dataType': 'string',
                        'width': 200,
                        'align': 'left',
                        'overflowAsTip': false,
                        'format': null,
                        'asTpl': false
                    }, {
                        'name': 'outerUnsettled',
                        'title': '未结算资产',
                        'dataType': 'bool',
                        'width': 100,
                        'align': 'center',
                        'overflowAsTip': false,
                        'format': '是/否',
                        'asTpl': false
                    }];
                    tableData.cols = exportCols;
                } else {

                }
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData(type);
                rowsSrc.url = '/shop/device/page/list';
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(type) {
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    let ids = [];
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                }
                filterItems.exportFlag = true;
                if (type != null && type == 'outerUnsettled') {
                    filterItems.id = -1;
                }
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
            showDeprSpec(deprSpecId) {
                openDeprSpecDetailDlg(deprSpecId);
            },
            generalImport() {
                let self = this;
                let usage = 'asset.update.import';
                let uploadParams = {
                    title: '资产导入检查',
                    fileGroup: 'device.import',
                    multipleFile: false,
                    usage: usage,
                    lableText: '更新导入',
                    downloadText: '导出数据',
                };
                fileUploadGroupShowDlg(uploadParams, null, function (result, theDlg) {
                    // theDlg 关闭弹框
                    theDlg.close();
                    if (result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if (!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join('<br/>'));
                            return;
                        }
                        //
                        let deviceImpInfoList = self.file.extra.deviceImpInfoList;
                        if (deviceImpInfoList == null || deviceImpInfoList.length == 0) {
                            MsgBox.warning('文件中未解析到数据');
                            return;
                        }
                        for (let i = 0; i < deviceImpInfoList.length; i++) {
                            let deviceImpInfo = deviceImpInfoList[i];
                            deviceImpInfo.recItemId = null;
                        }
                        let deviceImpDto = {
                            retailerShopId: self.thisComId,
                            retailerBizUnitId: self.thisBizUnitId,
                            originalFileName: self.file.extra.originalFileName,
                            virtualFlag: false,
                            tplUsage: usage,
                            updateFlag: true
                        };
                        self.startDone(deviceImpDto, deviceImpInfoList, 1, 1000);
                    } else {
                        MsgBox.warning(result.message);
                    }
                }, function () {
                    self.exportModel();
                });
            },
            startDone(srcImpDto, srcImpInfoList, pageNumber, pageSize) {
                let self = this;
                let paramImpDto = Utils.merge({}, srcImpDto);
                let totalCount = srcImpInfoList.length;
                let start = (pageNumber - 1) * pageSize;
                let end = pageNumber * pageSize;
                let paramImpInfoList = srcImpInfoList.slice(start, end);
                paramImpDto.deviceImpInfoList = paramImpInfoList;
                paramImpDto.lastFlag = end >= totalCount;
                // end/totalCount
                let theLoading = MsgBox.loading('正在处理【' + (end > totalCount ? totalCount : end) + '/' + totalCount + '】，请稍后...');
                devcApi.saveDeviceImpModel(paramImpDto, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        srcImpDto.importRecId = result.data;
                    } else if (paramImpDto.importRecId == null) {
                        // 第一此都没过去，记录没生成,直接结束
                        MsgBox.warning(result.message);
                        return;
                    }
                    if (end < totalCount) {
                        pageNumber = pageNumber + 1;
                        self.startDone(srcImpDto, srcImpInfoList, pageNumber, pageSize);
                    } else {
                        // 最后一批结束
                        MsgBox.info('文件数据保存成功,请检查通过后执行导入');
                    }
                });
            },
            exportModel() {
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    if (multipleSelection.length > 20000) {
                        MsgBox.warning('一次最多导出2万条数据');
                        return;
                    }
                    let ids = [];
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                } else {
                    if (this.totalCount > 20000) {
                        MsgBox.warning('一次最多导出2万条数据');
                        return;
                    }
                }
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                devcApi.saveWaitInFiscalDeviceImpParamsForExport(postData, function (result) {
                    Utils.setPageUrl(getAppUrl(result.data + '&usage=asset.update.import'), '_blank');
                });
            },
            taskExport() {
                if (this.totalCount <= 0) {
                    Toast.show('没有需要导出的数据');
                    return;
                }
                let self = this;
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                tableData.data = this.getPostData(null);
                tableData.pageSize = 1000;
                tableData.fileRows = 500000;
                if (!Utils.isNoB(tableData.cols) && tableData.cols.length > 0) {
                    let extra = {
                        'name': 'retailerComName_Id',
                        'title': '所在机构信息（用于导入）',
                        'dataType': 'string',
                        'format': null,
                        'align': 'left',
                        'width': 140,
                        'group': null
                    };
                    tableData.cols.push(extra);
                }
                let asynTaskInfo = {};
                asynTaskInfo.ownerId = this.scopeEntity.id;
                asynTaskInfo.ownerType = this.scopeEntity.scopeId;
                asynTaskInfo.bizCode = 'zctz.list.export';
                asynTaskInfo.paramInfo = JSON.encode(tableData);
                // 检查唯一键
                let theLoad = MsgBox.loading();
                comnApi.getAsynTaskInfoByUk(asynTaskInfo, function (result) {
                    theLoad.hide();
                    if (result.type == 'info') {
                        let data = result.data;
                        if (data == null) {
                            createTaskExportDlg(asynTaskInfo, function () {
                            });
                        } else {
                            if (data.phase == 3 || data.phase == -1) {
                                self.$confirm('已经创建了相同参数的任务【' + data.title + '】,确定要重新创建吗?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    createTaskExportDlg(asynTaskInfo, function () {
                                    });
                                }).catch(function () {

                                });
                            } else {
                                MsgBox.warning('已经创建了相同参数的任务【' + data.title + '】且正在进行中,无法重新创建');
                            }
                        }
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            viewTaskExport() {
                let params = {};
                params.ownerId = this.scopeEntity.id;
                params.ownerType = this.scopeEntity.scopeId;
                params.bizCode = 'zctz.list.export';
                viewTaskExportListDlg(params);
            },
            // 跳转页面
            toLockedBizVoucher: function (row) {
                let tanKuangFlag = false;
                let deprAdjust = false;
                let bizVoucherText = '';
                let devcVoucherType = null;
                if (Utils.isTrue(row.fiscalLocked)) {
                    devcVoucherType = getEnumInfoWith('devcVoucherType', 'value', row.fiscalLockBizType);
                    if (devcVoucherType.name == 'Allocation' || devcVoucherType.name == 'Scrap' || devcVoucherType.name == 'Clear' || devcVoucherType.name == 'DeprAdjust') {
                        tanKuangFlag = true;
                        if (devcVoucherType.name == 'Allocation') {
                            if (row.fiscalAcctFlag == 1) {
                                bizVoucherText = '调拨';
                            } else {
                                bizVoucherText = '设备调拨';
                            }
                        } else if (devcVoucherType.name == 'DeprAdjust') {
                            bizVoucherText = '价值调整';
                            deprAdjust = true;
                        } else {
                            bizVoucherText = devcVoucherType.text;
                        }
                    }
                } else if (Utils.isTrue(row.locked)) {
                    devcVoucherType = getEnumInfoWith('devcVoucherType', 'value', row.lockBizType);
                    if (devcVoucherType.name == 'Allocation' || devcVoucherType.name == 'Scrap' || devcVoucherType.name == 'Clear' || devcVoucherType.name == 'DeprAdjust') {
                        tanKuangFlag = true;
                        if (devcVoucherType.name == 'Allocation') {
                            if (row.fiscalAcctFlag == 1) {
                                bizVoucherText = '调拨';
                            } else {
                                bizVoucherText = '设备调拨';
                            }
                        } else if (devcVoucherType.name == 'DeprAdjust') {
                            bizVoucherText = '价值调整';
                            deprAdjust = true;
                        } else {
                            bizVoucherText = devcVoucherType.text;
                        }
                    }
                }
                //
                let query = null;
                if (devcVoucherType.name != 'Clear' && devcVoucherType.name != 'Receive' && devcVoucherType.name != 'Appturn') {
                    if (!Utils.isNoB(row.fiscalLockBizInnerNo)) {
                        query = {
                            innerNo: row.fiscalLockBizInnerNo
                        };
                    } else if (!Utils.isNoB(row.fiscalLockBizNo)) {
                        query = {
                            no: row.fiscalLockBizNo
                        };
                    } else if (!Utils.isNoB(row.lockBizInnerNo)) {
                        query = {
                            innerNo: row.lockBizInnerNo
                        };
                    } else if (!Utils.isNoB(row.lockBizNo)) {
                        query = {
                            no: row.lockBizNo
                        };
                    }
                } else {
                    if (!Utils.isNoB(row.fiscalLockBizNo)) {
                        query = {
                            no: row.fiscalLockBizNo
                        };
                    } else if (!Utils.isNoB(row.lockBizNo)) {
                        query = {
                            no: row.lockBizNo
                        };
                    }
                }
                //
                if (tanKuangFlag) {
                    let theDlg = Vue.$showDialog({
                        title: '选择跳转到的页面',
                        showCloseBtn: true,
                        okVisible: false,
                        cancelVisible: false,
                        cancelText: '关闭',
                        width: 200,
                        height: 150,
                        template: '<div><button class="swb-btn swb-btn-small" @click="toApplyPage()" v-if="deprAdjust">{{bizVoucherText}}申请</button>' +
                            '<button class="swb-btn swb-btn-small" @click="toApplyPage()" v-if="!deprAdjust">申请{{bizVoucherText}}</button>' +
                            '<br/>' +
                            '<button class="swb-btn swb-btn-small mt10" @click="toAuditPage()" v-if="deprAdjust">{{bizVoucherText}}审核</button>' +
                            '<button class="swb-btn swb-btn-small mt10" @click="toAuditPage()" v-if="!deprAdjust">审核{{bizVoucherText}}</button></div>',
                        data: {
                            bizVoucherText: null,
                            deprAdjust: false
                        },
                        methods: {
                            // 跳转到申请列表
                            toApplyPage: function () {
                                let hashUrl = null;
                                if (devcVoucherType.name == 'Allocation') {
                                    if (row.fiscalAcctFlag == 1) {
                                        hashUrl = SwbShopDeviceTransVoucherApplyList.path;
                                    } else {
                                        hashUrl = SwbShopDeviceTransVoucherDevcApplyList.path;
                                    }
                                } else if (devcVoucherType.name == 'Scrap') {
                                    hashUrl = SwbShopDeviceScrapVoucherApplyList.path;
                                } else if (devcVoucherType.name == 'Clear') {
                                    hashUrl = SwbShopDeviceClearVoucherApplyList.path;
                                } else {
                                    hashUrl = SwbAssetDeprAdjustVoucherList.path;
                                }
                                //
                                if (query != null) {
                                    hashUrl = Utils.makeUrl(hashUrl, query);
                                }
                                openPageRouteUrl(null, '/bench/home', hashUrl);
                                theDlg.close();
                            },
                            // 跳转到审核列表
                            toAuditPage: function () {
                                let hashUrl = null;
                                if (devcVoucherType.name == 'Allocation') {
                                    if (row.fiscalAcctFlag == 1) {
                                        hashUrl = SwbShopDeviceTransVoucherAuditList.path;
                                    } else {
                                        hashUrl = SwbShopDeviceTransVoucherDevcAuditList.path;
                                    }
                                } else if (devcVoucherType.name == 'Scrap') {
                                    hashUrl = SwbShopDeviceScrapVoucherAuditList.path;
                                } else if (devcVoucherType.name == 'Clear') {
                                    hashUrl = SwbShopDeviceClearVoucherAuditList.path;
                                } else {
                                    hashUrl = SwbAssetDeprAdjustVoucherAuditList.path;
                                }
                                if (query != null) {
                                    hashUrl = Utils.makeUrl(hashUrl, query);
                                }
                                openPageRouteUrl(null, '/bench/home', hashUrl);
                                theDlg.close();
                            }
                        },
                        okClicked: function () {
                        },
                        lifecycle: {
                            created: function () {
                                this.bizVoucherText = bizVoucherText;
                                this.deprAdjust = deprAdjust;
                            }
                        }
                    });
                } else {
                    let hashUrl = null;
                    if (devcVoucherType.name == 'DevcSplit') {
                        // 资产拆分
                        hashUrl = SwbDevcSplitFormList.path;
                    } else if (devcVoucherType.name == 'DevcMerge') {
                        // 资产合并
                        hashUrl = SwbDevcMergeFormList.path;
                    } else if (devcVoucherType.name == 'ManualReceipt') {
                        // 费用验收
                        hashUrl = SwbPurchReceiptManualList.path;
                    } else if (devcVoucherType.name == 'Receive') {
                        // 领用
                        hashUrl = SwbShopDeviceAppturnVoucherList.path;
                    } else if (devcVoucherType.name == 'Appturn') {
                        // 归还
                        hashUrl = SwbShopDeviceAppReturnVoucherList.path;
                    } else {
                        return;
                    }
                    if (query != null) {
                        hashUrl = Utils.makeUrl(hashUrl, query);
                    }
                    openPageRouteUrl(null, '/bench/home', hashUrl);
                }
            },
            viewImpRec() {
                Vue.$showDialog({
                    title: '资产导入更新记录',
                    width: 1000,
                    height: 700,
                    okVisible: false,
                    cancelVisible: false,
                    showCloseBtn: true,
                    template: '<swb-shop-devc-imp-rec-asset-update-list></swb-shop-devc-imp-rec-asset-update-list>',
                    data: {}
                });
            }
        }
    }
</script>

<style>
    .form-value.radio .el-radio + .el-radio {
        margin-left: 0;
    }

    .form-value.radio {
        width: calc(100% - 126px - 20px);
        width: -webkit-calc(100% - 126px - 20px);
        width: -moz-calc(100% - 126px - 20px);
    }
</style>



// WEBPACK FOOTER //
// src/compo/devc/ShopDeviceAssetList.vue